import { Location } from '@hooks/useGeolocation'

/**
 * Generates a Google Maps navigation URL with optional origin
 * @param destination - Destination coordinates
 * @param origin - Optional origin coordinates (current location)
 * @returns Google Maps directions URL
 */
export function getNavigationUrl(
  destination: { latitude: number; longitude: number },
  origin?: Location | null
): string {
  const destCoords = `${destination.latitude},${destination.longitude}`

  if (origin && origin.latitude && origin.longitude) {
    // Include origin for better routing
    const originCoords = `${origin.latitude},${origin.longitude}`
    return `https://www.google.com/maps/dir/?api=1&origin=${originCoords}&destination=${destCoords}`
  }

  // No origin - Google Maps will use user's current location
  return `https://www.google.com/maps/dir/?api=1&destination=${destCoords}`
}

/**
 * Opens navigation in a new window/tab or native app
 * @param destination - Destination coordinates
 * @param origin - Optional origin coordinates
 */
export function navigateTo(
  destination: { latitude: number; longitude: number },
  origin?: Location | null
): void {
  const url = getNavigationUrl(destination, origin)
  window.open(url, '_blank')
}
